import { Directive, ElementRef, Input, OnDestroy, OnInit, inject } from '@angular/core';
import Sortable, {Options} from 'sortablejs';

/**
 * Wrapper around Sortable.js.
 * `ngx-sortablejs` is not working with Angular 15+.
 */
@Directive({
    selector: '[appSortable]',
    standalone: false
})
export class SortableDirective implements OnInit, OnDestroy {
    private el = inject<ElementRef<HTMLElement>>(ElementRef);

    @Input('appSortable') options: Options = {};

    private sortable: Sortable | undefined;

    ngOnInit(): void {
        this.sortable = Sortable.create(this.el.nativeElement, this.options);
    }

    ngOnDestroy(): void {
        this.sortable?.destroy();
    }
}
